import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const [status, setStatus] = useState({ loading: true, ok: false });

  useEffect(() => {
    let mounted = true;

    axios.post('/qpra/verify-session', {}, { withCredentials: true })
      .then(({ data }) => {
        const isValid = !!data?.isValid;
        const roles = data?.user?.roles ?? [];

        const roleOk = Array.isArray(allowedRoles) && allowedRoles.length > 0
          ? roles.some(r => allowedRoles.includes(r))
          : true; // if no allowedRoles provided, only require valid session

        if (mounted) setStatus({ loading: false, ok: isValid && roleOk });
      })
      .catch(() => mounted && setStatus({ loading: false, ok: false }));

    return () => { mounted = false; };
  }, [allowedRoles]);

  if (status.loading) return <div>Loading...</div>;
  if (!status.ok) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
